// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles__containerCodes___eqtax{display:grid;grid-gap:20px;width:60%;margin:0 auto}", "",{"version":3,"sources":["webpack://./src/containers/wasm/codes/styles.scss"],"names":[],"mappings":"AAAA,gCACE,YAAA,CAEA,aAAA,CACA,SAAA,CACA,aAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerCodes": "styles__containerCodes___eqtax"
};
export default ___CSS_LOADER_EXPORT___;
